import React from 'react'
import { SearchArea } from './components/SearchArea/SearchArea';


export const Home = ({cocktail,setCocktail,text,setText,fetchCocktail,handleSubmit,showId}) => {
  return (
    <div className=' text-center mt-auto  mb-auto '>
      <SearchArea 
      cocktail={cocktail}
      setCocktail={setCocktail}
      text={text}
      setText={setText}
      fetchCocktail={fetchCocktail}
      handleSubmit={handleSubmit}
      showId={showId}
      />
      </div>
  )
}
